import { CardSection } from "containers/Manual/components/section/CardSection";
import { Img } from "containers/Manual/components/content/Image";
import { Li } from "containers/Manual/components/list/Li";
import { ListSection } from "containers/Manual/components/section/ListSection";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Ul } from "containers/Manual/components/list/Ul";
import { TableSection } from "containers/Manual/components/section/TableSection";

export const ABS = () => {
  return (
    <CardSection id="ABS" title="ABS">
      <Paragraph>
        실수의 절대값(ABS)을 반환합니다. 수학 표기법에서는 절대값이 양쪽에
        막대로 표시됩니다. 예를 들어, <b>x</b>의 절대값은 <b>|x|</b>로
        작성됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ABS(VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 절대값을 구하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>
      <ListSection title="Example">
        <Paragraph accent>ABS(`Column`)</Paragraph>
        <Img src="computeAbs" />

        {/* <TableSection
          rowData={[{ Column: 41, "New Column (1)": 41 }]}
          columnData={[
            {
              id: "Column",
              name: "Column",
              key: "Column",
              originalColumnName: "Column",
              type: "NUMBER",
            },
            {
              id: "New Column (1)",
              name: "New Column (1)",
              key: "New Column (1)",
              originalColumnName: "New Column (1)",
              type: "NUMBER",
            },
          ]}
        /> */}
      </ListSection>
      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 실수, 실수를 포함하는 열 또는 실수를 반환하는
          함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>ABS</b>는 수직선에서 주어진 숫자가 0으로부터 떨어진 거리를
          의미합니다. 숫자가 0으로부터 얼마나 떨어져 있는지는, 숫자가 0의
          오른쪽(양수) 또는 왼쪽(음수)에 있는지와 관계없이 동일한 절대적인
          거리로 나타냅니다. 수학 표기법에서는 절대값을 숫자 양쪽에 막대를 그어
          표시합니다. 예를 들어, <b>x</b>의 절대값은 <b>|x|</b>로 작성됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
